import Alert from './Alert';
import AlertFooter from './AlertFooter';
import AlertTitle from './AlertTitle';

export default Object.assign(Alert, {
  Title: AlertTitle,
  Footer: AlertFooter,
});
